<template>
<el-container>
<el-main>
     <el-dialog
    :title="$t('roomDetail.addLockAuth')"
    :visible.sync="addAuthDialogVisible"
    width="480px"
    style="margin-top:-30px"
    >
      <el-form :inline="true" :model="addAutoForm" ref="selectForm" class="demo-ruleForm">
        <el-form-item :label="$t('tenantDetail.chooseRoom')" label-width="120">
         <el-select v-model="addAutoForm.lockId" filterable :placeholder="$t('tenantDetail.chooseAuthRoom')" @change="tenantSelectChange" style="width:220px">
          <el-option
          v-for="item in addAutoForm.roomData"
          :key="item.deviceId"
          :label="item.roomName"
          :value="item.deviceId">
          </el-option>
        </el-select>
       </el-form-item>
       <el-form-item :label="$t('roomDetail.authType')" label-width="120">
            <el-radio v-model="addAutoForm.validType" label="0">{{$t('roomDetail.password')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="1">{{$t('roomDetail.doorCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="2">{{$t('roomDetail.idCard')}}</el-radio>
            <el-radio v-model="addAutoForm.validType" label="3">{{$t('roomDetail.fingerprint')}}</el-radio>
       </el-form-item>  
       </br> 
       <el-form-item :label="$t('roomDetail.authContent')" label-width="120" v-show="addAutoForm.validType==0">
           <el-input v-model="addAutoForm.validData" :placeholder="$t('roomDetail.msgCreateSjPassword')" style="width:220px"></el-input>
       </el-form-item>   
       <el-form-item :label="$t('roomDetail.beginTime')" label-width="120">
        
           <el-date-picker
           v-model="addAutoForm.beginTime"
           type="datetime"
           :disabled="addAutoForm.beginFlag"
           :placeholder="$t('roomDetail.chooseBeginTime')">
           </el-date-picker>
         
       </el-form-item>  
       <el-form-item :label="$t('roomDetail.endTime')" label-width="120">
         <div class="block">
           <el-date-picker
           v-model="addAutoForm.endTime"
           type="datetime"
           :disabled="addAutoForm.endFlag"
           :placeholder="$t('roomDetail.chooseEndTime')">
           </el-date-picker>
         </div>
       </el-form-item>
       <el-footer>
         <el-button type="primary" @click="confirmAddAuth">{{$t('roomDetail.confirm')}}</el-button>
         <el-button @click="addAuthDialogVisible = false">{{$t('roomDetail.cancle')}}</el-button>
       </el-footer>  
     </el-form>      
    </el-dialog>
  <el-card class="box-card">
     <div slot="header" class="clearfix">
        <el-link icon="el-icon-back" type="success" @click="back">{{$t('roomDetail.back')}}</el-link>
          <!-- <el-button type="primary" size="small" style="float:right" @click="backHome">返回</el-button> -->
          <!-- <el-button type="primary" size="small" style="float:right" @click="getOffLinePassword">{{$t('roomDetail.getOfflinePassword')}}</el-button> -->
     </div>
     <el-form :inline="true" ref="selectForm" class="demo-ruleForm">
         <el-form-item :label="$t('tenantDetail.tenantName')" style="width:230px">
            {{this.tenantDetailData.tenantName}}
         </el-form-item>    
         <el-form-item :label="$t('tenantDetail.tenantPhone')" style="width:230px">
            {{this.tenantDetailData.tenantPhone}}
         </el-form-item>
         <el-form-item :label="$t('tenantDetail.tenantEmail')" style="width:230px">
            {{this.tenantDetailData.tenantEmail}}
         </el-form-item>
         <el-form-item :label="$t('tenantDetail.status')" style="width:230px">
            {{this.tenantDetailData.status==0?$t('tenantDetail.noShow'):this.tenantDetailData.status==1?$t('tenantDetail.hasBeenIn'):''}}
         </el-form-item>
        <el-form-item :label="$t('tenantDetail.cardNo')" style="width:230px">
            {{this.tenantDetailData.cardNo}}
         </el-form-item>
          <el-form-item :label="$t('tenantDetail.idCard')" style="width:230px">
            {{this.tenantDetailData.tenantIdentityId}}
         </el-form-item>
         <el-form-item :label="$t('tenantDetail.fingerprint')" style="width:230px">
             {{this.tenantDetailData.fingerType==0?$t('fingerprintList.undefined'):this.tenantDetailData.fingerType==1?$t('fingerprintList.leftThumb'):this.tenantDetailData.fingerType==2?$t('fingerprintList.leftIndexFinger'):this.tenantDetailData.fingerType==3?$t('fingerprintList.leftHandMiddleFinger'):this.tenantDetailData.fingerType==4?$t('fingerprintList.ringFingerOfLeftHand'):this.tenantDetailData.fingerType==5?$t('fingerprintList.leftTailToRefer'):
             this.tenantDetailData.fingerType==6?$t('fingerprintList.rightThumb'):this.tenantDetailData.fingerType==7?$t('fingerprintList.rightIndexFinger'):this.tenantDetailData.fingerType==8?$t('fingerprintList.rightHandMiddleFinger'):this.tenantDetailData.fingerType==9?$t('fingerprintList.ringFingerOfRightHand'):this.tenantDetailData.fingerType==10?$t('fingerprintList.rightTailToRefer'):""}} 
         </el-form-item>
     </el-form>
    </el-card>
    <el-card class="box-card">
     <el-tabs v-model="activeName" type="card" @tab-click="">
      <el-tab-pane :label="$t('tenantDetail.roomList')" name="userList">
         <!-- <el-input style="width:280px" v-model="selectForm.tenantName" placeholder="请输入租客名称，多个租客以逗号分隔"></el-input>
         <el-button type="primary"  icon="el-icon-search" @click="queryTenant">查询</el-button> -->
         <el-button type="primary"  @click="batchCheckOut">{{$t('roomDetail.batchCheckOut')}}</el-button>
         <el-button type="primary"  @click="shuaxin">{{$t('roomDetail.refresh')}}</el-button>
         <el-table
         :data="roomPageData.roomData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         @selection-change="userDataSelectionChange"
         >
        
        <el-table-column
         type="selection"
         width="55">
        </el-table-column>
         
        <el-table-column
         prop="apartmentName"
         :label="$t('tenantDetail.apartmentName')">
        </el-table-column>

        <el-table-column
         prop="tenantName"
         :label="$t('roomDetail.tenantName')">
        </el-table-column>

        <el-table-column
         prop="isManager"
         :label="$t('roomDetail.userType')">
         <template slot-scope="scope">
           {{scope.row.isManager==0?$t('roomDetail.tenant'):scope.row.isManager==1?$t('roomDetail.admin'):""}}
         </template>
        </el-table-column>

        <el-table-column
         prop="roomName"
         :label="$t('roomDetail.roomName')">
        </el-table-column>

       <!-- <el-table-column
         prop="status"
         label="状态">
       </el-table-column> -->

       <!-- <el-table-column
         prop="isLimit"
         label="是否有限期">
          <template slot-scope="scope">
             {{scope.row.isLimit==0?"无限期":scope.row.isLimit==1?"有限期":""}}
          </template> 
       </el-table-column> -->

        <el-table-column
         prop="beginTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.beginTime')">
       </el-table-column>

        <el-table-column
         prop="endTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.endTime')">
       </el-table-column>
     
         </el-table>
      <el-footer>
      <div>
        <Pagings
        :total="roomPageData.total"
        :offset="roomPageData.offset"
        :pageSize="roomPageData.pageNumber"
        @handleSizeChangeSub="roomHandleSizeChange"
        @handleCurrentChangeSub="roomHandleCurrentChange">
        </Pagings>
      </div>
      </el-footer> 
      </el-tab-pane>  
      <el-tab-pane :label="$t('roomDetail.authList')" name="authList">
        <el-button type="primary"  @click="openAddAuthDialog">{{$t('roomDetail.addAuth')}}</el-button>
        <el-button type="primary"  icon="el-icon-search" @click="shuaxin">{{$t('roomDetail.refresh')}}</el-button>
         <el-table
         :data="authPageData.authData"
         :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
         empty-text="No Data"
         border
         style="margin-top: 5px"
         :row-class-name="tableRowClassName"
         >

        <el-table-column 
        type="index" 
        :label="$t('systemRecord.number')" 
        width="100" 
        align="center">
        </el-table-column>
        
        <el-table-column
         prop="validType"
          width=100
         :label="$t('roomDetail.authType')">
         <template slot-scope="scope">
          {{scope.row.validType==0?$t('roomDetail.password'):scope.row.validType==1?$t('roomDetail.doorCard'):scope.row.validType==2?$t('roomDetail.idCard'):scope.row.validType==3?$t('roomDetail.fingerprint'):scope.row.validType==4?$t('roomDetail.bluetooth'):""}}
         </template>
        </el-table-column>

         <el-table-column
         prop="authorizationUserId"
         width="80"
         :label="$t('roomDetail.authId')">
        </el-table-column>

         <el-table-column
         prop="authorizationName"
         width="100"
         :label="$t('roomDetail.authName')">
        </el-table-column>

        <el-table-column
         prop="roomName"
         width="80"
         :label="$t('tenantDetail.authRoom')">
        </el-table-column>

       <el-table-column
         prop="validData"
         :label="$t('roomDetail.authContent')">
         <template slot-scope="scope">
           <!-- {{scope.row.validUser==3?JSON.parse(scope.row.validData).data:scope.row.validData}} -->
           <span  v-if="scope.row.validUser==3">
            {{JSON.parse(scope.row.validData).data}}
          </span> 
          <span v-else> 
            <span v-show="scope.row.validType==0">
             <span v-if="scope.row.index === tabClickIndex">
              {{scope.row.validData}}
              <i @click="hidePassWord(scope.row)" style="cursor: pointer;" class="el-icon-view"></i>
              </span>
             <span v-else>
              ******
              <i @click="showPassWord(scope.row)" style="color:blue;cursor: pointer;" class="el-icon-view"></i>
             </span>
            </span>
            <span v-show="scope.row.validType!=0">
              {{scope.row.validData}}
            </span>
          </span>  
         </template>  
       </el-table-column>

        <el-table-column
         prop="status"
         width=100
         :label="$t('roomDetail.authStatus')">
          <template slot-scope="scope">
             {{scope.row.status==0?$t('roomDetail.stop'):scope.row.status==1?$t('roomDetail.start'):scope.row.status==2?$t('roomDetail.invalid'):scope.row.status==3?$t('roomDetail.delete'):scope.row.status==4?$t('roomDetail.toDelete'):scope.row.status==5?$t('fingerprintList.freeze'):""}}
          </template>  
       </el-table-column>

        <el-table-column
         prop="beginTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.beginTime')">
       </el-table-column>

        <el-table-column
         prop="endTime"
         :formatter="this.$util.datetimeFormat"
         :label="$t('roomDetail.endTime')">
       </el-table-column>

      <el-table-column
       prop
       :label="$t('roomDetail.operate')"
       width="180"
       align="center"
      >
       <template slot-scope="scope">

        <el-button
          type="warning"
          size="mini"
          v-show="scope.row.status==1"
          @click="freezeAuth(scope.$index, scope.row)"
         >{{$t('fingerprintList.freeze')}}</el-button>

        <el-button
          type="primary"
          size="mini"
          v-show="scope.row.status==5"
          @click="removeAuth(scope.$index, scope.row)"
         >{{$t('deviceList.thaw')}}</el-button>

        <el-button
          type="danger"
          size="mini"
          @click="deleteAuth(scope.$index, scope.row)"
         >{{$t('roomDetail.delete')}}</el-button>

       </template>
      </el-table-column>
     
      </el-table>
      <el-footer>
       <div>
        <Pagings
        :total="authPageData.total"
        :offset="authPageData.offset"
        :pageSize="authPageData.pageNumber"
        @handleSizeChangeSub="authHandleSizeChange"
        @handleCurrentChangeSub="authHandleCurrentChange">
        </Pagings>
       </div>
      </el-footer> 
      </el-tab-pane> 
     </el-tabs>  
    </el-card> 
</el-main>
</el-container>    
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "roomDetail",
  data() {
     return {
         selectForm:{
           tenantName:""
         },
         activeName:"userList",
         tenantDetailData:"",
         roomPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           roomData: []
         },
         authPageData:{
           offset: 1,
           pageNumber: 10,
           total: 0, //总条数
           authData: []
         },
         multipleSelection: [],
         addAuthDialogVisible:false,
         addAutoForm:{
          beginTime:"",
          endTime:"",
          isLimit:0,
          isLocked:0,
          isOpen:0,
          validType:'0',
          userId:"",
          roomId:"",
          deviceId:"",
          roomData:[],
          validData:""
       },
       tabClickIndex:''
     }
  },
  components: {
    Pagings
  },
  mounted() {
      this.getTenantDetail();
      this.getRoomPage();
      this.getAuthPage();

      // if(this.deviceId!=""&&this.deviceId!=null){
      //   this.getDeviceDetail();
      //   this.getAuthPage();
      // }
  },  

  methods: {
    tableRowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    //显示密码
    showPassWord(row){
      this.tabClickIndex=row.index;
    },
    //隐藏密码
    hidePassWord(){
      this.tabClickIndex='';
    },
    //解除
    removeAuth(index,row){
       this.$confirm(this.$t("deviceList.confirmUnfreeze"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var authInfoId=row.infoId;
                  var formData = new FormData();
                  formData.append("authInfoId",authInfoId);
                  formData.append("status",2);//冻结
                  this.$server
                   .exam("/customer/lock/editLockAuthAuthorization", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.getAuthPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                 message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },
    //冻结
    freezeAuth(index,row){
       this.$confirm(this.$t("deviceList.confirmFreeze"),this.$t("tenant.hint"), {
              confirmButtonText: this.$t("tenant.confirm"),
              cancelButtonText: this.$t("tenant.cancel"),
                type: 'warning'
              }).then(() => {
                  var authInfoId=row.infoId;
                  var formData = new FormData();
                  formData.append("authInfoId",authInfoId);
                  formData.append("status",1);//冻结
                  this.$server
                   .exam("/customer/lock/editLockAuthAuthorization", formData)
                   .then(data => {
                     if (data.code == 200) {
                        this.$message({
                         message:this.$t('roomDetail.authSuccess'),
                         type: "success"
                        });
                       this.getAuthPage();
                      } else {
                        this.$message({
                          message: data.message,
                          type: "warning"
                        });
                      }
                    });  
              }).catch(() => {
                this.$message({
                  type: 'info',
                 message: this.$t("tenant.cancelDelete")
                }); 
              });     
    },

    //租客查询
    queryTenant(){
      this.getUserPage();
    },
    //返回
    back(){
      this.$router.push({path:"/tenantList",query: {apartmentId:this.apartmentId}});
    },
    //租客选择
    tenantSelectChange(val){
     this.addAutoForm.deviceId=val.deviceId;
     var obj = {};
     obj = this.addAutoForm.roomData.find((item)=>{//遍历list的数据
       return item.deviceId === val;//筛选出匹配数据
     });
     this.addAutoForm.deviceId=obj.deviceId;
     this.addAutoForm.beginTime=this.$util.formartDateTime(obj.beginTime);
     this.addAutoForm.endTime=this.$util.formartDateTime(obj.endTime);
     this.addAutoForm.beginFlag=true;
      this.addAutoForm.endFlag=true;
    },
    //确定添加授权
    confirmAddAuth(){
      if(this.addAutoForm.lockId==""||this.addAutoForm.lockId==null){
        this.$message({
            message:this.$t('tenantDetail.chooseAuthRoom'),
            type: "warning"
        });
        return false;
      }
      var formData = new FormData();
      if(this.addAutoForm.beginTime!=""&&this.addAutoForm.endTime!=""){
        formData.append("beginTime",this.$util.formartDateTime(this.addAutoForm.beginTime));
        formData.append("endTime",this.$util.formartDateTime(this.addAutoForm.endTime));
      }else{
         this.$message({
            message:this.$t('roomDetail.chooseCheckInTime'),
            type: "warning"
          });
          return false;
      }
      // if(this.addAutoForm.tenantName==""||this.addAutoForm.tenantName==null){
      //   this.$message({
      //       message:this.$t('tenant.tenantName-input'),
      //       type: "warning"
      //     });
      //     return false;
      // }
       formData.append("authorizationName",this.addAutoForm.deviceId+this.$t('roomDetail.msg1'));
       formData.append("isLimit",1);
       formData.append("validUser ",2);//临时用户
       formData.append("validType",this.addAutoForm.validType);
       if(this.addAutoForm.validType=="0"){
        formData.append("validData",this.addAutoForm.validData);
       }
       formData.append("isLocked",0);
       formData.append("isOpen",0);
       formData.append("isSendSms",0);
       formData.append("lockId",this.addAutoForm.lockId);
       formData.append("userId",this.$route.query.tenantId);//租客ID
      this.$server
      .exam("/customer/lock/addLockAuthorization", formData)
      .then(data => {
        if (data.code == 200) {
          this.addAuthDialogVisible=false;
          this.$message({
            message:this.$t('roomDetail.authSuccess'),
            type: "success"
          });
          this.getAuthPage();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },
     getAuthPage(){
        var formData = new FormData();
        formData.append("tenantId",this.$route.query.tenantId);
        formData.append("pageNo", this.authPageData.offset);
        formData.append("pageSize", this.authPageData.pageNumber);
        this.$server
        .exam("/customer/tenant/pageTenantLockAuthorization", formData)
        .then(data => {
          if (data.code == 200) {
            this.authPageData.authData=data.data.records;
            this.authPageData.total = data.data.total;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
    //打开添加授权页面
    openAddAuthDialog(){
      this.addAuthDialogVisible=true;
    },
    //删除授权
    deleteAuth(index,row){
       var errorTxt="";
       if(row.status==4){
        errorTxt="二次操作将会直接从数据库删除授权，请确认是否继续?";
       }else{
        errorTxt=this.$t('deviceDetail.deleteAuth-confirm1')+row.authorizationName+this.$t('deviceDetail.deleteAuth-confirm2'),this.$t('deviceDetail.hint');
       }
       this.$confirm(errorTxt,{
          confirmButtonText: this.$t('deviceDetail.confirm'),
          cancelButtonText: this.$t('deviceDetail.cancel'),
          type: 'warning'
        }).then(() => {
           var formData = new FormData();
           formData.append("authInfoId", row.infoId);
           formData.append("isDelete", 0);
           this.$server
          .exam("/customer/apartment/deleteLockAuthorization", formData)
          .then(data => {
            if (data.code == 200) {
               this.getAuthPage();
               this.$message({
                  message:this.$t('roomDetail.deleteAuthSuccess'),
                  type: "success"
                });
            } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
           }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('deviceDetail.cancleDelete')
          });          
        });
    },
    //刷新用户列表
    shuaxin(){
      this.getRoomPage();
      this.getAuthPage();
      this.$message({
        message:this.$t('roomDetail.refreshSuccess'),
        type: "success"
      });
    },
    //批量退租
    batchCheckOut(){
      if(this.multipleSelection.length==0||this.multipleSelection==""){
          this.$message({
            message:this.$t('roomDetail.chooseCheckOutTenant'),
            type: "success"
          });
          return false;
      }
    this.$confirm(this.$t('roomDetail.confirmCheckOut'), this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
    }).then(() => {
      var formData = new FormData();
      formData.append("roomIdList",JSON.stringify(this.jxRoomData()));
      formData.append("tenantId", this.$route.query.tenantId);
      this.$server
      .exam("/customer/tenant/tenantCheckOut", formData)
      .then(data => {
        if (data.code == 200) {
           this.$message({
            message:this.$t('roomDetail.checkOutSuccess'),
            type: "success"
          });
          this.getRoomPage();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }).catch(() => {
        this.$message({
          type: 'info',
          message:this.$t("tenant.cancelCheckOut")
        });          
    });  
    },
    //入住租客选择
    userDataSelectionChange(val){
       this.multipleSelection=val;
    },
    jxRoomData(){  
        var rtnData=[];
        var roomData=this.multipleSelection;
        console.log(JSON.stringify(roomData));
        for(var i=0;i<roomData.length;i++){
          var obj={};
          obj.roomId=roomData[i].roomId;
          rtnData.push(obj);
        }
        return rtnData;
    },
   
    getTenantDetail(){
      var formData = new FormData();
      formData.append("tenantId", this.$route.query.tenantId);
      this.$server
      .exam("/customer/tenant/getTenantDetail", formData)
      .then(data => {
        if (data.code == 200) {
          console.log(data.data);
          this.tenantDetailData=data.data;    
          this.addAutoForm.roomData=data.data.apartmentRoomTenantLinkers;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    }, 

     getRoomList(){
        var formData = new FormData();
        formData.append("associatedUserId", this.$route.query.tenantId);
        formData.append("pageNo", 100);
        formData.append("pageSize",1);
        this.$server
        .exam("/customer/room/listTenantAuthorized", formData)
        .then(data => {
          if (data.code == 200) {
            this.addAutoForm.roomData=data.data.records;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },
   
    getRoomPage(){
        var formData = new FormData();
        formData.append("associatedUserId", this.$route.query.tenantId);
        formData.append("pageNo", this.roomPageData.offset);
        formData.append("pageSize", this.roomPageData.pageNumber);
        this.$server
        .exam("/customer/room/listTenantAuthorized", formData)
        .then(data => {
          if (data.code == 200) {
            this.roomPageData.roomData=data.data.records;
            this.roomPageData.total = data.data.total;
          }
          else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
    },

     roomHandleSizeChange(val) {
       this.roomPageData.pageNumber = val;
       this.getRoomPage();
     },
     roomHandleCurrentChange(val) {
       this.roomPageData.offset = val;
       this.getRoomPage();
     },
     authHandleSizeChange(val) {
       this.authPageData.pageNumber = val;
       this.getAuthPage();
     },
     authHandleCurrentChange(val) {
       this.authPageData.offset = val;
       this.getAuthPage();
     }
  }           
}
</script>

<style>
 .el-dialog__header{
  border-bottom: 1px solid #e8eaec;
}
.el-dialog__footer {
  border-top: 1px solid #e8eaec;
}
</style>


// WEBPACK FOOTER //
// src/components/tenant/tenantDetail.vue